import {Injectable} from '@angular/core';
import {JwtHelperService} from '@auth0/angular-jwt';
import * as _ from 'lodash';

@Injectable({
    providedIn: 'root'
})
export class JwtDecoderService {
    private token: any;

    constructor() {
    }

    private getToken() {
        this.token = sessionStorage.getItem('LOGICHECK.token');
        if (this.token !== undefined) {
            const helper = new JwtHelperService();
            return helper.decodeToken(this.token);
        }
    }

    public isAuthenticated(): boolean {
        return !!this.getAuthToken();
    }

    public getAuthToken() {
        return sessionStorage.getItem('LOGICHECK.token');
    }

    public getUsername() {
        if (this.isAuthenticated()) {
            const decodedToken = this.getToken();

            if (decodedToken !== undefined && decodedToken.data) {
                return decodedToken.data.username;
            }
        }
        return null;
    }

    public getRoles() {
        if (this.isAuthenticated()) {
            const decodedToken = this.getToken();
            if (decodedToken !== undefined && decodedToken.data) {
                return decodedToken.data.roles;
            }/* else if (decodedToken && decodedToken['realm_access']) {
                return decodedToken['realm_access'].roles;
            } else if (decodedToken && decodedToken.scope && decodedToken.scope === '/F///FUNC/2000803028///X') {
                return ['MIWAP_USER'];
            }*/
        }
        return null;
    }

    public hasRole(role: string) {
        if (this.isAuthenticated()) {
            const roles = this.getRoles();
            if (roles) {
                if (roles.includes(role)) {
                    return true;
                }
                const obj = _.find(roles, ['name', role]);
                return obj !== undefined;
            }
        }
        return false;
    }

    public hasPermission(permission: string) {
        if (this.isAuthenticated()) {
            const roles = this.getRoles();
            if (roles) {
                for (const role of roles) {
                    if (role === permission) {
                        return true;
                    }
                    if (role.permissions && role.permissions.length > 0) {
                        for (const perm of role.permissions) {
                            if (perm === permission) {
                                return true;
                            }
                        }
                    }
                }
            }
        }
        return false;
    }


}
